import { WebglSettingsConverter } from "../../webgl-settings-converter";
import { VisualizatorSettings } from "../../../settings/visualizator-settings";
import { getItemByField, ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelWebglSettingsConverter extends WebglSettingsConverter {
  constructor(commonSettings, configurationConverter) {
    super();
    this.commonSettings = commonSettings;
    this.configurationConverter = configurationConverter;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    delete settingsCopy.id_channel;
    settingsCopy.id = settings.id_channel;
    let commonChannelSettings = settings._commonSettings;
    if (commonChannelSettings !== undefined) {
      for (const key of Object.getOwnPropertyNames(commonChannelSettings)) {
        if (key == "configurations") {
          if (settings.configurations !== undefined) {
            settingsCopy.configurations = [];
            for (let configIndex = 0; configIndex < settings.configurations.length; configIndex++) {
              let configSettings = settings.configurations[configIndex].copy();
              configSettings.id_dataSource = settings.id_dataSource;
              configSettings.id_channel = settings.id_channel;
              configSettings._commonSettings = getItemByField(
                "name",
                settings.configurations[configIndex].name_configuration,
                commonChannelSettings.configurations
              );
              configSettings._plotSettings = settings._plotSettings;
              configSettings._isNeedChannelLeadRay = settings._isNeedChannelLeadRay;
              configSettings._isSynchronizedScaleX = settings._isSynchronizedScaleX;
              let convertedConfigSettings = this.configurationConverter.convert(configSettings);
              if (convertedConfigSettings !== undefined) {
                settingsCopy.configurations.push(convertedConfigSettings);
              }
            }
          }
        } else if (settingsCopy[key] === undefined) {
          if (commonChannelSettings[key] instanceof VisualizatorSettings) {
            settingsCopy[key] = commonChannelSettings[key].copy();
          } else {
            settingsCopy[key] = ObjectCreator.deepCopy(commonChannelSettings[key]);
          }
        }
      }
    }
    if (settingsCopy.freq === undefined && settingsCopy.defaultFreq !== undefined) {
      settingsCopy.freq = settingsCopy.defaultFreq;
    }
    return settingsCopy;
  }
}
